module.exports = __webpack_public_path__ + "img/63000.b304fe9e.jpg";